export const footer = {
  footerTitleGame: "Los mejores juegos",
  footerTitleGameCasino: "Casino",
  footerTitleGameLottery: "Lotería",
  footerTitleGameGames: "Mini juegos",
  footerTitleSports: "Deportes",
  footerTitleGameSlots: "Slots",
  footerTitleGameHorses: "Hipismo",
  footerTitleGameMesa: "Juegos de mesa",
  footerTitleGameMinigame: "Minijuegos",
  footerTitleLiga: "Las ligas ganadoras",
  footerTitleLigaEsports: "E-Sports",
  footerTitleLigaLeague: "La Liga",
  footerTitleLigaFootball: "Liga de Campeones de la UEFA",
  footerTitleSupport: "Soporte",
  footerTitleHelp: "Centro de ayuda",
  footerTitleTerms: "Términos y condiciones",
  footerTitleSocial: "Síguenos",
  footerTitleApp: "Descarga nuestra app",
  footerTitlePromotions: "Promociones",
  footerTitleResponsibleGambling: "Juega con responsabilidad. Solo para mayores de 18 años.",
  footerTitleSafeGame: "Todo por un juego más seguro",
};
